import { useQuery } from '@tanstack/react-query';

import { NotificationResource } from '@/types/resources';
import { api } from '@/utils/api';

interface NotificationData {
  freelancer_id: string;
  signed_at: string;
  signer_name: string;
}

export type Notifications = Array<NotificationResource<NotificationData>>;

const useDocumentSignedNotifications = (
  userId?: number | string,
  enabled = true,
  onlyUnread = true,
) => {
  const queryKey = [
    'document_signed',
    {
      notifiableType: 'App\\Notifications\\DocumentSigned',
      notifiableId: userId,
      onlyUnread,
    },
  ];

  const { data: notifications } = useQuery<Notifications>(
    queryKey,
    () =>
      api.get<never, Notifications>('/v1/notifications', {
        params: {
          'filter[type]': 'App\\Notifications\\DocumentSigned',
          ...(onlyUnread && { 'filter[unread]': 1 }),
          'filter[notifiable_type]': 'App\\Models\\User',
          ...(userId && { 'filter[notifiable_id]': userId }),
          sort: onlyUnread ? '-created_at' : 'unread_first',
        },
      }),
    {
      staleTime: 60 * 1000,
      enabled,
      refetchOnWindowFocus: true,
    },
  );

  return {
    notifications,
    queryKey,
  };
};

export default useDocumentSignedNotifications;
